module.exports = __webpack_public_path__ + "media/images/nabit-5bef6813d90d5a673093e900483834a1.png";